// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1DKyt","square":"styles_square__3HCRn"};